@if (notificationBarService.getNotification() | async; as notification) {
  <div
    class="container"
    [ngStyle]="{ 'background-color': notificationColor$ | async }"
    >
    <div class="spacer"></div>
    <span class="text">{{ notification.text }}</span>
    <div class="spacer"></div>
    @if (notification.closeable) {
      <button
        mat-icon-button
        class="close-button"
        aria-label="Close the notification"
        (click)="onClose()"
        >
        <mat-icon style="color: white">close</mat-icon>
      </button>
    }
  </div>
}
